import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axios";

export const fetchCalibrations = createAsyncThunk(
    "calibrations/fetchCalibrations",
    async ({ search, filters, page, pageSize }) => {
        const params = {};
        if (search) {
            params.search = search;
        }
        if (filters.clinics) {
            params.clinics = filters.clinics;
        }
        if (filters.category) {
            params.category = filters.category;
        }
        if (filters.brand) {
            params.brand = filters.brand;
        }
        if (filters.model) {
            params.model = filters.model;
        }

        params.page = page;
        params.pageSize = pageSize;

        const response = await axiosInstance.get("/equipment/calibrations", { params: params });
        return {
            data: response.data,
            total: response.headers["x-total-count"],
        };
    }
);

const calibrationsSlice = createSlice({
    name: "calibrations",
    initialState: {
        data: [],
        status: "idle",
        error: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCalibrations.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchCalibrations.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.data = action.payload;
            })
            .addCase(fetchCalibrations.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    },
});

export default calibrationsSlice.reducer;